module.exports = __webpack_public_path__ + "img/qrcode.7edb1793.jpg";